var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/components/x-buildify-width-picker.ts
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/fonts/fonts.js";
import "@adornis/popover/x-dropdown-selection";
import { customElement, property } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { html } from "lit/html.js";
import "../../db/GlobalSettings.js";
import { XBuildifyGlobalSettingsFormField } from "./x-buildify-global-settings-formfield.js";
var XBuildifyWidthPicker = class extends XBuildifyGlobalSettingsFormField {
  styles() {
    return [...super.styles(), { ":host": { height: "100%" } }];
  }
  render() {
    return xComponents(this.content());
  }
  content() {
    if (!this._consumedGlobalSettingsClassName.value)
      return this._freeForm();
    return this._selectable();
  }
  _selectable() {
    return html`
      <x-dropdown-selection
        ${injectAttributesOf(this)}
        .selectables=${this._globalSettings.value?.widths}
        @value-picked=${(e) => e.detail.value ? this._commitValue(e.detail.value._id) : this._commitValue()}
        .value=${this._globalSettings.value?.widths?.find((widthDef) => widthDef._id === this.value.value)}
        .renderString=${(widthDef) => widthDef?.name ?? ""}
      ></x-dropdown-selection>
    `;
  }
  _freeForm() {
    return html`
      <x-input
        .value=${this.value.value}
        ${injectAttributesOf(this)}
        @value-picked=${(e) => {
      this.value.next(e.detail.value);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
    }}
        error=${ifDefined(this.error)}
      >
      </x-input>
    `;
  }
  _commitValue(widthDefID) {
    if (!widthDefID)
      this.value.next(null);
    else
      this.value.next(widthDefID);
    this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
  }
  get configuration() {
    return {
      icons: {
        advancedSettings: "tune"
      }
    };
  }
};
__decorateClass([
  property()
], XBuildifyWidthPicker.prototype, "placeholder", 2);
XBuildifyWidthPicker = __decorateClass([
  customElement("x-buildify-width-picker")
], XBuildifyWidthPicker);
export {
  XBuildifyWidthPicker
};
